import React, { useEffect, useState } from "react";
import axios from "axios";
import apiconfig from "../../config/api-config.js";
import Paper from "@mui/material/Paper";
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import ShowBoxCard from "./TrackTables/ShowBoxComponents/ShowBoxCard";

const ShowBoxes = (props) => {
  const [collections, setCollections] = useState([]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    scrollToTop();

    if (!collections) {
      let axiosUrl =
        "https://api.fliktrax.com/newreleases?category=44blue-productions&playlist=[]";
      axios({
        baseURL: axiosUrl,
        method: "get",
        auth: {
          username: apiconfig.api.APIUSERNAME,
          password: apiconfig.api.APIPASSWORD,
        },
        headers: {
          "Content-Type": "application/hal+json",
        },
        //timeout: 2000,
      }).then((response) => {
        setCollections(response.data._embedded.newreleases);
      });
    }
  }, [collections]);

  return (
    <Container
      className="ft-container"
      maxWidth="md"
      style={{ marginTop: "5vh" }}
    >
      <h1>Show Boxes</h1>
      <Box>
        <CssBaseline />
        <Grid container spacing={4}>
          {collections && collections.length === 0 && (
            <>
              <Grid item md={12}>
                <Paper
                  sx={{
                    backgroundColor: "#343d3f",
                    color: "white",
                    padding: 3,
                    marginTop: 5,
                    fontSize: "1.2em",
                  }}
                  elevation={3}
                >
                  <SentimentDissatisfiedIcon style={{ marginRight: 10 }} />
                  No ShowBoxes Yet ... Stay Tuned ...
                </Paper>
              </Grid>
            </>
          )}

          {collections &&
            collections.map((data, i) => {
              return (
                <>
                  <Grid item xs={12} sm={6} md={6}>
                    <ShowBoxCard cardData={data} />
                  </Grid>
                </>
              );
            })}
        </Grid>
      </Box>
    </Container>
  );
};

export default ShowBoxes;
